<app-board *ngIf="boardCards && accountVars && !loading; else loader" [boardCards]="boardCards"
  [compact]="platformService.isSmall" [variables]="accountVars"></app-board>

<ng-template #loader>
  <app-loader class="margin" message="Chargement du compte..."></app-loader>
</ng-template>
